import { css } from 'lit-element';
export default css `
      .f_02 {
      fill: var(--stair-inside-color);

    }

    .f_03 {
      fill: var(--stair-border-color);
    }

    .f_stair {
      fill: var(--stair-color);
    }


    .f_04 {
      fill: #0CBED0;
    }

    .f_05 {
      fill: #FE9297;
    }

    .f_06 {
      fill: #F3828A;
    }

    .f_07 {
      fill: #FEAFB1;
    }

    .f_08 {
      fill: #F3818A;
    }

    .f_09 {
      fill: #303763;
    }

    .f_10 {
      fill: #ECB507;
    }

    .f_11 {
      fill: #F8C100;
    }

    .f_12 {
      fill: #F79800;
    }

    .f_81 {
      fill: #F9C200;
    }

    .f_13 {
      fill: #F6AB83;
    }

    .f_14 {
      fill: #F66A00;
    }

    .f_15 {
      fill: #D38B68;
    }

    .f_16 {
      fill: #FAAC82;
    }

    .f_17 {
      fill: #E58C5C;
    }

    .f_19 {
      fill: #E78F5E;
    }

    .f_20 {
      fill: #FBAD83;
    }

    .f_50 {
      fill: #FFFFFF;
    }

    .f_52 {
      fill: #EFEFEF;
    }


    .f_89 {
      fill: #CECCCD;
    }

    .f_90 {
      fill: #D1D6D9;
    }

    .f_54 {
      fill: #C9C9C9;
    }

    .f_35 {
      fill: #E48C5C;
    }

    .f_36 {
      fill: #22180E;
    }

    .f_37 {
      fill: #F9AC82;
    }

    .f_44 {
      fill: #19192B;
    }

    .f_47 {
      fill: #A9C2DC;
    }

    .f_43 {
      fill: #50CAD3;
    }

    .f_75 {
      fill: #5FD5E5;
    }

    .f_22 {
      fill: #60D5E5;
    }

    .f_26 {
      fill: #A8C1DB;
    }

    .f_24 {
      fill: #50C9D2;
    }

    .f_55 {
      fill: #05C99D;
    }

    .f_78 {
      fill: #00C99C;
    }

    .f_82 {
      fill: #0CBFD1;
    }

    .f_57 {
      fill: #059972;
    }

    .f_56 {
      fill: #8B3CA5;
    }

    .f_58 {
      fill: #EE9CA6;
    }

    .f_59 {
      fill: #A45B3A;
    }

    .f_60 {
      fill: #FE9398;
    }

    .f_61 {
      fill: #8E4A2F;
    }

    .f_62 {
      fill: #F67112;
    }

    .f_63 {
      fill: #E68D5D;
    }

    .f_64 {
      fill: #F6700F;
    }

    .f_65 {
      fill: #E89162;
    }

    .f_66 {
      fill: #E46107;
    }

    .f_67 {
      fill: #E46108;
    }

    .f_68 {
      fill: #EE843C;
    }

    .f_69 {
      fill: #F9AC83;
    }

    .f_71 {
      fill: #E28F61;
    }

    .f_73 {
      fill: #E38F62;
    }

    .f_74 {
      fill: #FD9398;
    }

    .f_53 {
      fill: #F06389;
    }

    .f_76 {
      fill: #A45B3B;
    }

    .f_77 {
      fill: #FFA9AD;
    }

    .f_79 {
      fill: #E68D5C;
    }

    .f_83 {
      fill: #EE7B29;
    }

    .f_84 {
      fill: #E5670E;
    }

    .f_27 {
      fill: #5277C3;
    }

    .f_29 {
      fill: #4F69D0;
    }

    .f_30 {
      fill: #5376C3;
    }

    .f_86 {
      fill: #1E5597;
    }

    .f_87 {
      fill: #3985EC;
    }

    .f_21 {
      fill: #204A98;
    }

    .f_88 {
      fill: #0B63DA;
    }

    .f_45 {
      fill: #303D72;
    }

    .f_46 {
      fill: #27345E;
    }

    .f_72 {
      fill: #4871B2;
    }

    .f_80 {
      fill: #19182B;
    }

    .f_70 {
      fill: #1A2249;
    }
`